import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import NotificationManager from '@adc/ui-components/services/notification-manager';
import { POST } from '@adc/ajax/services/adc-ajax';

import type Ajax from 'unattended-showing/services/ajax';
import type { Registry as ServiceRegistry } from '@ember/service';
import type { ModelFrom } from '../../../../../customer-site/app/utils/type-utils';
import type PhoneVerificationGuestCheckoutRoute from './route';

export default class ContextPhoneVerificationGuestCheckoutController extends Controller {
    @service declare store: ServiceRegistry['store'];
    @service declare router: ServiceRegistry['router'];
    @service declare ajax: Ajax;
    @service declare notificationManager: NotificationManager;

    declare model: ModelFrom<PhoneVerificationGuestCheckoutRoute>;

    @action
    async handleVerificationCodeSubmit(code: string): Promise<void> {
        try {
            if (this.model.phoneVerificationGuest == null) {
                this.notificationManager.addError(
                    'Guest information is missing.'
                );
                return;
            }

            // Save the code to the model.
            this.model.phoneVerificationGuest.userEnteredCode = code;

            // phone verification POST
            this.model.phoneVerificationGuest = await this.ajax.apiRequest(
                'phoneVerifications/verifyCodeGuest',
                undefined,
                this.model.phoneVerificationGuest,
                POST
            );

            this.notificationManager.addSuccess(
                'Your phone has been verified!'
            );
            this.router.transitionTo(
                'context.sign-up-sgt3.credit-card-verification',
                {
                    queryParams: {
                        jwt: this.model.phoneVerificationGuest.jwt
                    }
                }
            );
        } catch (error) {
            let errorMessages = error?.errors?.errors ?? error?.errors ?? [];

            // Make sure errorMessages is an array.
            if (typeof errorMessages === 'string') {
                errorMessages = [errorMessages];
            }

            // Show the error message first since we're handling the error here.
            errorMessages.forEach((errorMessage: { detail: any }) =>
                this.notificationManager.addError(errorMessage.detail ?? error)
            );

            return;
        }
    }

    @action
    async handleResendCode(): Promise<void> {
        await this.ajax.apiRequest(
            'phoneVerifications/resendCodeGuest',
            undefined,
            this.model.phoneVerificationGuest,
            POST
        );

        this.notificationManager.addSuccess(
            'A new code has been sent to you phone!'
        );
    }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
    interface Registry {
        'context/phone-verification/guest-checkout': ContextPhoneVerificationGuestCheckoutController;
    }
}
